var _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2BF7E"
    },
    d: "M407.836,424.369H295.776v47.733c0,0,7.417,31.65,40.026,32.007s40.017-31.869,40.017-31.869 S374.549,424.369,407.836,424.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4E4AC"
    },
    d: "M455.847,488.106h-80.018v-30.465c0-18.528,15.02-33.549,33.549-33.549h1.867 c24.633,0,44.602,19.969,44.602,44.602L455.847,488.106L455.847,488.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2BF7E"
    },
    d: "M357.244,384.084h-61.432v-96.021c0-13.258,10.748-24.006,24.006-24.006l0,0 c13.258,0,24.006,10.748,24.006,24.006v15.503c0,26.761,5.106,53.275,15.045,78.121l0,0 C359.326,382.835,358.48,384.084,357.244,384.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4E4AC"
    },
    d: "M335.82,504.318c-22.096,0-40.009-18.017-40.009-40.113c0,0-0.229-111.404,0-159.879 s24.006-39.853,24.006-39.853H71.762c-13.258,0-24.246,10.332-24.246,23.59v176.039c0,22.096,18.154,40.217,40.25,40.217H335.82 V504.318z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.771,
    y: 16.003,
    style: {
      fill: "#E2804F"
    },
    width: 368.078,
    height: 56.016
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4E4AC"
    },
    d: "M379.414,384.084L379.414,384.084c-19.657,0-35.593-15.935-35.593-35.593c0,0-0.531-33.331,0-44.425 c1.905-39.81-24.006-40.009-24.006-40.009H135.777V40.009h288.062v299.65C423.839,364.194,403.95,384.084,379.414,384.084z"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "471.849,80.017 439.843,80.017 439.843,64.013 455.846,64.013 455.846,16.003 103.769,16.003 103.769,64.013  119.773,64.013 119.773,80.017 87.766,80.017 87.766,0 471.849,0 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 175.856,
    y: 87.743,
    width: 104.143,
    height: 15.779
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.856,
    y: 120.354,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.195,
    height: 15.779
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 215.83,
    y: 120.354,
    width: 15.779,
    height: 15.779
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240.025,
    y: 120.354,
    width: 15.779,
    height: 15.779
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 264.22,
    y: 120.354,
    width: 15.779,
    height: 15.779
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 175.856,
    y: 160.328,
    width: 208.287,
    height: 15.779
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.856,
    y: 191.887,
    style: {
      fill: "#FFFFFF"
    },
    width: 208.287,
    height: 15.779
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 175.856,
    y: 224.497,
    width: 208.287,
    height: 15.779
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 359.948,
    y: 256.056,
    width: 24.195,
    height: 15.779
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 359.948,
    y: 288.666,
    width: 24.195,
    height: 15.779
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 359.948,
    y: 320.225,
    width: 24.195,
    height: 15.779
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 87.492,
    y: 296.03,
    width: 168.312,
    height: 15.779
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.44,
    y: 328.64,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.195,
    height: 15.779
  }), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 207.414,
    y: 328.64,
    width: 48.39,
    height: 15.779
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 207.414,
    y: 360.199,
    width: 48.39,
    height: 15.779
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.44,
    y: 360.199,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.195,
    height: 15.779
  }), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 87.492,
    y: 415.953,
    width: 79.948,
    height: 15.779
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.025,
    y: 415.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.779,
    height: 15.779
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.83,
    y: 415.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.779,
    height: 15.779
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.635,
    y: 415.953,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.779,
    height: 15.779
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 87.492,
    y: 455.927,
    width: 168.312,
    height: 15.779
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.076,416.203c-0.17,0-0.339,0.012-0.509,0.013l-103.991-0.262l-0.039,15.779l69.019,0.174 c-7.758,8.511-12.493,19.811-12.493,32.194c0,17.711-14.354,32.119-31.996,32.119c-0.072,0-0.142-0.005-0.214-0.005v-0.005h-0.229 c-17.371-0.241-31.43-14.547-31.43-32.108V288.062c0-9.036,6.931-16.116,15.779-16.116c8.848,0,15.779,7.079,15.779,16.116v56.012 c0,12.277,4.644,23.486,12.26,31.972l-36.442-0.067l-0.028,15.779c0,0,71.14,0.215,72.073,0.215 c26.392,0,47.864-21.487,47.864-47.899V47.77h8.416V31.991H120.101V47.77h7.674v200.283h16.003V47.77H415.7v296.305 c0,17.711-14.394,32.119-32.085,32.119c-0.595,0-1.187-0.019-1.775-0.052v-0.034l-0.45-0.001 c-16.657-1.149-29.861-15.072-29.861-32.033v-56.012c0-17.587-14.157-31.895-31.559-31.895v-0.11H71.762 c-17.43,0-31.61,14.357-31.61,32.006v176.039c0,12.794,4.933,24.767,13.89,33.714c8.952,8.942,20.93,13.867,33.714,13.867 l247.866,0.307c0.148,0.001,0.295,0.012,0.443,0.012c26.343,0,47.775-21.487,47.775-47.899c0-17.539,14.183-31.831,31.721-32.107 l0.353,0.001v-0.009c0.054,0,0.106-0.004,0.16-0.004c17.774,0,32.235,14.409,32.235,32.119v16.021H384.14v15.779h79.948v-31.801 C464.089,437.69,442.55,416.203,416.076,416.203z M87.766,495.902c-17.851,0-31.834-13.969-31.834-31.801V288.062 c0-8.947,7.102-16.226,15.831-16.226h221.055c-2.794,4.757-4.405,10.304-4.405,16.226v176.039c0,12.322,4.655,23.568,12.287,32.065 L87.766,495.902z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.d15979d0cda3e67e56e4abd933a8990b.svg";
export { ForwardRef as ReactComponent };